export const initStateGeneralConcepts = (
   Object.assign({
      data                : [],
      concept_spanish     : '',
      concept_english     : '',
      select_kind_concept : '',
      generalConceptId    : '',
      actionForm          : false
   })
);